// Ported verbatim from the mobile app (PrecisionReactNative src/common/assets/images/equipment/eqBikeSVG.tsx); generated — regenerate rather than edit.
import * as React from "react";

type Props = {
  fill: string;
  width?: number;
  height?: number;
};

function EqBikeSVG(props: Props) {
  const {fill, width = 24, height = 24} = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none">
      <path
        d="M2 6H6L8 12.403"
        stroke="#1F2224"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M19 12L21.9 4.743C22.0213 4.43976 22.0666 4.11141 22.0317 3.78666C21.9969 3.46191 21.883 3.15063 21.7001 2.88003C21.5172 2.60942 21.2708 2.38773 20.9825 2.23433C20.6941 2.08092 20.3726 2.00047 20.046 2H17"
        stroke="#1F2224"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M6 19C7.10457 19 8 18.1046 8 17C8 15.8954 7.10457 15 6 15C4.89543 15 4 15.8954 4 17C4 18.1046 4.89543 19 6 19Z"
        stroke="#1F2224"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M20.965 16.173L7.682 12.311C7.14136 12.1188 6.57361 12.0139 6 12C4.67392 12 3.40215 12.5268 2.46447 13.4645C1.52678 14.4021 1 15.6739 1 17C1 18.3261 1.52678 19.5979 2.46447 20.5355C3.40215 21.4732 4.67392 22 6 22H20C20.7103 22.002 21.3981 21.7513 21.9404 21.2927C22.4828 20.8341 22.8443 20.1976 22.9604 19.4969C23.0764 18.7961 22.9394 18.077 22.5738 17.468C22.2083 16.8591 21.638 16.4 20.965 16.173Z"
        stroke="#1F2224"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
}

export default EqBikeSVG;
